export const defaultMCQValue = () => {
    return {
        type : 'S',
        has_custom_layout : false, // Whether to give custom layout creation
        option_buttons_each_row : 5,
        options: [],
        answer: [],
        allow_reading_options : false
    }
}

export const defaultOrderingValue = () => {
    return {
        options: [],
        answer: [],
        allow_reading_options : false
    }
}

export const defaultMCQOptionValue = (options_length) => {
    let styles = {
        border_width : 2,
        border_color : '#2acdc1',
        font_color : '#fff',
        font_size : 16,
        text_align : 'center'
    }
    return {
        name: "",
        option_type : "D",
        use_fraction_input: false,  // NEW: Flag for fraction input
        custom_width : null,
        layers : [],
        tables : [],
        clock : null,
        protractor: null,
        bar_chart : null,
        line_chart: null,
        thermometer: null,
        number_line: null,
        custom_layout : null,
        shapes : null,
        order : options_length + 1,
        is_hide_label : false,
        // Styles
        styles
    }
}